import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { http } from "../lib/market";

export const NotificationBell = () => {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const load = () => http.get("/notifications").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  const readAll = async () => { await http.post("/notifications/read-all"); load(); };
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative p-2.5 rounded-full border border-white/15 hover:border-turquoise/50 transition-colors">
          <Bell className="w-4 h-4 text-white/80" />
          {data.unread > 0 && <span data-testid="notification-unread-count" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-turquoise text-ink text-[10px] font-bold flex items-center justify-center">{data.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-ink border-white/10 text-white p-0" data-testid="notification-panel">
        <div className="flex justify-between items-center px-4 py-3 border-b border-white/10">
          <span className="font-montserrat text-[11px] uppercase tracking-wider">Notifications</span>
          <button onClick={readAll} className="text-turquoise text-xs" data-testid="notification-read-all">Mark all read</button>
        </div>
        <div className="max-h-96 overflow-auto">
          {data.notifications.length === 0 && <p className="p-4 font-inter text-sm text-white/45">You're all caught up.</p>}
          {data.notifications.slice(0, 30).map((n) => (
            <Link key={n.notification_id} to={n.link || "#"} onClick={() => http.post(`/notifications/${n.notification_id}/read`)} data-testid={`notification-item-${n.notification_id}`}
              className={`block px-4 py-3 border-b border-white/5 hover:bg-white/5 ${n.read ? "opacity-55" : ""}`}>
              <div className="font-inter text-sm text-white">{n.title}</div>
              <div className="font-inter text-xs text-white/55 mt-0.5">{n.body}</div>
              <div className="font-inter text-[10px] text-white/30 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </Link>))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
